import { inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { first, tap } from 'rxjs';
import { selectDocumentTypes } from './document-type.selectors';
import { fetchDocumentTypes } from './document-type.actions';

export const documentTypeResolver = () => {
  const store = inject(Store);
  return store.pipe(
    select(selectDocumentTypes),
    tap((documents) => {
      if (!documents || documents.length === 0) {
        store.dispatch(fetchDocumentTypes());
      }
    }),
    first()
  );
};
